module.exports = __webpack_public_path__ + "static/media/Elena_Makhalina.5edb4e22.jpg";